
import { communicationService } from './communicationService';
import { SystemEvent } from '../types';

export const emailService = {
  /**
   * Dispatches a unified relay event via the Vanguard Orchestration Engine.
   */
  async dispatchRelay(triggerType: 'WELCOME' | 'PULSE', recipient: string, payload: any): Promise<boolean> {
    const event: SystemEvent = triggerType === 'WELCOME' ? 'welcome_new_user' : 'partner_update';
    
    // Attempt to pull user session info if available to satisfy dependency checks
    const session = localStorage.getItem('priori_user_session');
    let userContext = {};
    if (session) {
      const u = JSON.parse(session);
      userContext = { userName: u.displayName, userEmail: u.email, userId: u.id };
    }

    const result = await communicationService.processEvent({
      to: recipient,
      event: event,
      context: {
        ...userContext,
        ...payload,
        timestamp: new Date().toLocaleString(),
        node: 'Legacy Overlay Relay'
      }
    });

    return result.success;
  }
};
